import {
  createHookStore,
  createUseSelector,
  STORE_NAMES
} from '@namespace/helpers-store';
import { gameStoreInitialState } from './constants';

export const useGamesStore = createHookStore(
  STORE_NAMES.GAMES_STORE,
  gameStoreInitialState
);

window.gamesStore = useGamesStore;

export const useGamesSelector = createUseSelector(useGamesStore);
